import React from 'react';
import {Box} from '@mui/material';
import {DataGrid, GridColDef, GridSortModel} from '@mui/x-data-grid';
import {GridPaginationModel} from "@mui/x-data-grid/models/gridPaginationProps";
import styles from './TransactionsComponent.module.css';
import {TransactionResponse, TransactionSummaryResponse} from "../../api/TransactionApi";
import {TransactionDetailsDialog} from "../TransactionDetailsDialog/TransactionDetailsDialog";
import {getStatusLabel} from "./statusLabels";


export const columns: GridColDef[] = [
    {field: 'transactionId', headerName: 'Transaction ID', width: 185, sortable: true, filterable: true},
    {field: 'totalAmount', headerName: 'Amount', width: 160, sortable: true, filterable: true},
    {field: 'transactionCurrency', headerName: 'Currency', width: 100, sortable: true, filterable: true},
    {
        field: 'transactionDate',
        headerName: 'Transaction date',
        width: 180,
        sortable: true,
        filterable: true
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 220,
        sortable: true,
        filterable: true,
        renderCell: params => getStatusLabel(params.value)
    },
    {field: 'merchantId', headerName: 'Merchant account', width: 240, sortable: true, filterable: true},
];

interface TransactionDataGridProps {
    rows: TransactionSummaryResponse;
    loading: boolean;
    sortModel: GridSortModel;
    pageModel: GridPaginationModel;
    onSortModelChange: (model: GridSortModel) => void;
    onPaginationModelChange: (model: GridPaginationModel) => void;
    onRowClick: (params: any) => void;
    height: number;
}
const TransactionDataGrid: React.FC<TransactionDataGridProps> = ({
                                                                         rows,
                                                                         loading,
                                                                         sortModel,
                                                                         pageModel,
                                                                         onSortModelChange,
                                                                         onPaginationModelChange,
                                                                         onRowClick,
                                                                         height
                                                                     }) => {
    return (
        <Box
            className={styles.gridWrapper}
            style={{height: `${height}px`}}
        >
            <DataGrid
                className={styles.dataGridRoot}
                classes={{
                    row: styles.dataGridRow,
                    cell: styles.dataGridCell
                }}
                rows={rows.entries}
                columns={columns}
                loading={loading}
                getRowId={(row:TransactionResponse) => row.transactionId}
                sortModel={sortModel}
                onSortModelChange={onSortModelChange}
                onRowClick={onRowClick}
                paginationMode="server"
                nonce={(window as any).__CSP_NONCE__}
                rowCount={rows.totalElements}
                pageSizeOptions={[25, 50, 100]}
                paginationModel={pageModel}
                onPaginationModelChange={onPaginationModelChange}
                disableRowSelectionOnClick={true}
                disableColumnMenu={true}
                disableVirtualization={true}
                density="standard"
            />
        </Box>
    );
};

export {TransactionDataGrid, TransactionDetailsDialog};
